export default {
  welcome: '欢迎使用TraceHub'
}
